'use strict';

var React = require('react'),
    Icon = require('../atoms/Icon'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    { PropTypes } = React;

require('./Loader.less');

var Loader = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    absoluteCenter: PropTypes.bool,
    withPadding: PropTypes.bool
  },

  getCSSModifiers() {
    return [
      this.props.absoluteCenter && 'absoluteCenter',
      this.props.withPadding && 'withPadding'
    ];
  },

  getDefaultProps() {
    return {
      withPadding: true
    };
  },

  render() {
    return (
      <div className={this.getClassName()}>
        <Icon name='spinner'
              size='medium'
              key='spinner'/>
      </div>
    );
  }
});

module.exports = Loader;



/** WEBPACK FOOTER **
 ** ./atoms/Loader.jsx
 **/